// Base Color Themes Configuration
// This file contains all the base color themes that are always available
//
// Additional color themes can be unlocked through easter eggs.
// See /src/config/easterEggs.ts for easter egg color definitions.

export interface ColorTheme {
  name: string
  primary: string
  secondary: string
}

// Base color themes that are always available (not locked behind easter eggs)
// Easter egg colors are automatically appended to these in getColorThemesWithLocks()
export const BASE_COLOR_THEMES: ColorTheme[] = [
    { name: 'Orange', primary: '#ff6b35', secondary: '#f7931e' },
    { name: 'Blue', primary: '#3b82f6', secondary: '#1e40af' },
    { name: 'Purple', primary: '#8b5cf6', secondary: '#7c3aed' },
    { name: 'Red', primary: '#ff1744', secondary: '#d50000' },
    { name: 'Cyan', primary: '#06b6d4', secondary: '#0891b2' },
    { name: 'Hot Pink', primary: '#ff1493', secondary: '#ff69b4' },
    { name: 'Green', primary: '#10b981', secondary: '#059669' },
]
